<template>
    <footer class="app-footer" v-if="this.$route.name != 'Video'">
        <div class="container">
            <div class="row">
                <div class="col-sm-6 col-md-3">
                    <ul class="quick-links">
                        <li><a href="https://www.young-enterprise.org.uk/teachers-hub/financial-education/financial-education-programmes/my-money-week/" target="_blank" rel="noopener" class="ym-link">{{appTextLanguage.footer.quickLinkReturn[language]}}</a></li>
                        <li><a href="https://www.young-enterprise.org.uk/advisoryservice" target="_blank" rel="noopener" class="ym-link">{{appTextLanguage.footer.quickLinkcontact[language]}}</a></li>
                    </ul>
                </div>
                <div class="col-sm-6 col-md-3">
                    <ul class="social-links">
                        <li><a href="https://www.facebook.com/YoungEnterpriseUK/" target="_blank" rel="noopener" title="Facebook" class="icon-fb"></a></li>
                        <li><a href="https://www.youtube.com/channel/UCyby3_NRERc2vDRMuc3bYiA" target="_blank" rel="noopener" title="YouTube" class="icon-yt"></a></li>
                        <li><a href="https://x.com/youngenterprise" target="_blank" rel="noopener" title="X" class="xIcon"><svg width="1200" height="1227" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="white"/>
</svg></a></li>
                    </ul>
                </div>
                <div class="col-sm-6 col-md-3">
                    <address>
                        Young Enterprise,<br/>
                        Coram Campus,<br/>
                        41 Brunswick Square,<br/>
                        London WC1N 1AZ
                    </address>
                </div>
                <div class="col-sm-6 col-md-3 partner-logos">
                    <a href="https://www.juniorachievement.org/web/ja-usa/home" target="_blank" rel="noopener">
                        <img src="../../assets/junior-achievement.png" alt="Junior achievement logo">
                    </a>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
    export default {
        name: 'Footer',
         data: function () {
            return {
                language: null,
            }
        },
        created(){
            this.appTextLanguage = this.$store.getters.getAppTextLanguage;
            this.language = this.$store.getters.getLanguage;
        },
         watch: {
            '$store.state.language': function () {
                this.language = this.$store.getters.getLanguage;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/global/AppFooter.vue